import React, { createContext, useState, useContext, useMemo } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

// Создаем контекст для темы
const ThemeContext = createContext();

// Хук для использования контекста темы
export const useTheme = () => useContext(ThemeContext);

// Провайдер темы
export const ThemeProvider = ({ children }) => {
  // Состояние для отслеживания текущего режима темы
  const [mode, setMode] = useState('light');

  // Функция для переключения темы
  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  // Создаем тему на основе текущего режима
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: mode === 'light' ? '#2e7d32' : '#66bb6a',
            light: mode === 'light' ? '#60ad5e' : '#98ee99',
            dark: mode === 'light' ? '#005005' : '#338a3e',
          },
          secondary: {
            main: mode === 'light' ? '#7cb342' : '#9ccc65',
            light: mode === 'light' ? '#aee571' : '#cfff95',
            dark: mode === 'light' ? '#4b830d' : '#6b9b37',
          },
          background: {
            default: mode === 'light' ? '#f2f6f2' : '#131a13',
            paper: mode === 'light' ? '#ffffff' : '#1e261e',
          },
        },
        typography: {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          h1: {
            fontWeight: 500,
          },
          h2: {
            fontWeight: 500,
          },
          h3: {
            fontWeight: 500,
          },
          h4: {
            fontWeight: 500,
          },
          h5: {
            fontWeight: 500,
          },
          h6: {
            fontWeight: 500,
          },
        },
        shape: {
          borderRadius: 8,
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: 'none',
                borderRadius: 8,
              },
            },
          },
          MuiCard: {
            styleOverrides: {
              root: {
                borderRadius: 12,
                boxShadow: mode === 'light' 
                  ? '0px 4px 20px rgba(0, 0, 0, 0.05)' 
                  : '0px 4px 20px rgba(0, 0, 0, 0.15)',
              },
            },
          },
        },
      }),
    [mode]
  );

  // Значения, передаваемые через контекст
  const value = {
    mode,
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}; 